<template>
  <div>
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div v-if="!$route.path.includes('agent')" class="card mb-3 p-3">
          <BaseText :maxlength="2000" :value="model.price" @input="model.price = $event" title="قیمت" placeholder="قیمت (تومان) " />
          <BaseText :maxlength="2000" :value="model.discount" @input="model.discount = $event" title="قیمت با تخفیف" placeholder="قیمت با تخفیف (تومان) " class="mt-2" />
        </div>

        <div class="card mb-3 p-3">
          <ComboBox
            v-if="!$route.path.includes('faculty') && !$route.path.includes('agent')"
            :searchedData="courseFacultis"
            title="نمایندگان"
            placeholder="نمایندگان"
            :required="$route.fullPath.includes('facultyskillupcourses') ? false : true"
            :showError="submit && !$route.path.includes('faculty') && !model.facultyId"
            :selectedValue="selectedFaculti"
            :errortext="errorText"
            @select="fillSelectedFaculti"
            :inputStyle="comboStyle"
          />
          <BaseText v-else disable :maxlength="2000" :value="model.facultyTitle" @input="model.facultyTitle = $event" title="نمایندگان" placeholder="نمایندگان" />
        </div>
        <div v-if="!$route.path.includes('agent')" class="card mb-3 p-3">
          <ComboBox
            :searchedData="collegues"
            title="دانشگاه‌های همکار"
            placeholder="دانشگاه‌های همکار"
            :selectedValue="selectedCollegue"
            @select="fillSelectedcollegue"
            :inputStyle="comboStyle"
          />
          <!-- <BaseText v-else disable :maxlength="2000" :value="model.facultyTitle" @input="model.facultyTitle = $event" title="دانشگاه‌های همکار" placeholder="دانشگاه‌های همکار" /> -->
        </div>
        <div class="card mb-3 p-3">
          <BaseText disable :maxlength="2000" :value="model.code" @input="model.code = $event" title="کد مجوز" placeholder="کد مجوز" />
          <!-- <div class="mt-2">
            <CountInput :value="model.capacity" @input="model.capacity = $event" title="تعداد ثبت نام" placeholder="تعداد ثبت نام" />
          </div> -->
        </div>
        <div class="card mb-3 p-3">
          <div class="section-title">وضعیت دوره <span style="color: rgb(254, 94, 97)">*</span></div>
          <Radio :componentData="cuorseTypes" :value="model.courseType" @input="model.courseType = $event" />

          <label v-if="submit && ![0, 1, 2].includes(model.courseType)" :class="{ course_type_error: submit && ![0, 1, 2].includes(model.courseType) }">{{ errorText }}</label>
        </div>
        <div class="card mb-3 p-3">
          <div class="section-title">موضوع <span style="color: rgb(254, 94, 97)">*</span></div>
          <div class="mt-3">
            <BaseText :maxlength="2000" :value="search" @input="search = $event" placeholder="جستجو" />
          </div>

          <div :class="{ subject: filteredCategory.length > 5 }">
            <Radio :componentData="filteredCategory" :value="model.courseCategoryId" @input="model.courseCategoryId = $event" />
          </div>

          <label v-if="submit && !model.courseCategoryId" :class="{ course_type_error: submit && !model.courseCategoryId }">{{ errorText }}</label>
          <div v-if="$route.path.includes('agent')" class="subject-tip">جهت افزودن موضوع جدید با واحد آموزش ارتباط برقرارکنید</div>
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-column justify-content-between">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <b-form-checkbox v-model="model.isDisplayable" class="pt-2">
                <div class="mx-1">نمایش در صفحه خانه</div>
              </b-form-checkbox>
              <b-form-checkbox v-model="model.organizational" class="pt-2">
                <div class="mx-1">دوره سازمانی</div>
              </b-form-checkbox>
              <b-form-checkbox v-model="model.allowSnapPay" class="pt-2">
                <div class="mx-1">پرداخت با اسنپ‌پی</div>
              </b-form-checkbox>
            </div>
            <div class="d-flex flex-column">
              <b-form-checkbox v-model="model.isEnable" class="pt-2">
                <div class="mx-1">عدم نمایش دوره</div>
              </b-form-checkbox>

              <b-form-checkbox v-model="model.enableForMembers" class="pt-2 d-flex align-items-center membersEnable">
                <div class="mx-1 w-100">فعال بودن دوره فقط برای اعضا</div>
              </b-form-checkbox>
              <b-form-checkbox v-model="model.isRecommended" class="pt-2">
                <div class="mx-1">دوره پیشنهادی</div>
              </b-form-checkbox>
            </div>
          </div>

          <div class="justify-content-end d-flex mt-3">
            <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
              <i class="far fa-times-circle"></i>
              <span class="ms-2">حذف دوره</span>
            </b-button>
          </div>
        </div>
        <div class="card p-3 mt-3">
          <BaseText :maxlength="2000" v-model="model.order" title="ترتیب دوره پیشنهادی" placeholder="" class="mt-2" />
        </div>

        <div class="inner__style mt-3">
          <div
            v-if="images.length === 0"
            class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center"
            @click="(event) => (images.length === 2 ? event.preventDefault() : $refs.fileInput.click())"
          >
            <div>
              <i :class="['fas fa-cloud-upload-alt __icon', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              <div class="upload-text-size">عکس دوره را انتخاب کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="uploaded-photo-main">
              <div v-for="(image, index) in images" :key="index" class="uploaded-photo">
                <div class="remove-icon" @click="removeImage({ index, image })">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" @click="changeSelectedImage(image)" :src="image" :class="{ selected: model.selectedImage == image }" />
              </div>
              <div v-if="images.length < 2" @click="() => $refs.fileInput.click()" class="uploaded-photo addNewImageIconContainer">
                <i :class="['fa fa-plus', { 'fas fa-spinner fa-spin': cropperLoading }]"></i>
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput
              :maxlength="100"
              :value="model.selectedImageAlternateText"
              @input="model.selectedImageAlternateText = $event"
              title="متن جایگزین 1"
              placeholder="متن جایگزین"
              rows="2"
            />
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین 2" placeholder="متن جایگزین" />
          </div>
          <input style="display: none" type="file" accept="image/*" @change="onFileSelected" ref="fileInput" />
        </div>
        <div class="card my-3 p-4">
          <div class="d-flex flex-column">
            <div :class="['upload_video my-4', { 'justify-content-start': model.summaryVideo && !videoLoading }]" @click="onOpenSummaryVideoModal">
              <div v-if="model.summaryVideo || summaryVideoLoading">
                <div>
                  <i v-if="summaryVideoLoading" class="fas fa-spin fa-spinner icon-size"></i>

                  <div v-else style="position: relative">
                    <div>
                      <video :src="model.summaryVideo" controls class="video" />

                      <i class="fas fa-times-circle close_icon" @click="model.summaryVideo = ''"></i>
                    </div>
                  </div>

                  <div v-if="summaryVideoLoading" class="pro">
                    <div class="progress-b">
                      <b-progress :value="summaryVideoPercentCompleted ? summaryVideoPercentCompleted : 0" :max="100" animated height="10" />
                    </div>

                    <div class="percent">{{ summaryVideoPercentCompleted ? summaryVideoPercentCompleted : 0 }}%</div>
                  </div>
                </div>
              </div>

              <div v-else>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">خلاصه ویدئو دوره را انتخاب کنید</div>

                <div class="second_upload_text">ویدئو به صورت افقی باید برگزاری شود</div>
              </div>
            </div>
            <BaseText v-model="model.summaryVideoName" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div class="card my-3 p-4">
          <div class="d-flex flex-column">
            <div :class="['upload_video my-4', { 'justify-content-start': model.video && !videoLoading }]" @click="onOpenVideoModal">
              <div v-if="model.video || videoLoading">
                <div>
                  <i v-if="videoLoading" class="fas fa-spin fa-spinner icon-size"></i>

                  <div v-else style="position: relative">
                    <div>
                      <video :src="model.video" controls class="video" />

                      <i class="fas fa-times-circle close_icon" @click="model.video = ''"></i>
                    </div>
                  </div>

                  <div v-if="videoLoading" class="pro">
                    <div class="progress-b">
                      <b-progress :value="videoPercentCompleted ? videoPercentCompleted : 0" :max="100" animated height="10" />
                    </div>

                    <div class="percent">{{ videoPercentCompleted ? videoPercentCompleted : 0 }}%</div>
                  </div>
                </div>
              </div>

              <div v-else>
                <i class="fas fa-cloud-upload-alt icon-size"></i>

                <div class="upload_text">ویدئو تبلیغاتی دوره را انتخاب کنید</div>

                <div class="second_upload_text">ویدئو به صورت افقی باید برگزاری شود</div>
              </div>
            </div>
            <BaseText v-model="model.videoName" title="نام ویدئو" placeholder="نام ویدئو" />
          </div>
        </div>

        <div v-if="model.licenseStatus && model.licenseStatus > 0" class="card mt-3 p-3">
          <div class="d-flex justify-content-between">
            <strong>وضعیت درخواست</strong>
            <div v-if="model.licenseStatus === 4" class="accept-badge">تایید شده</div>
            <div v-if="model.licenseStatus === 3" class="reject-badge">رد شده</div>
            <div v-if="model.licenseStatus === 2" class="need-badge">نیاز به اصلاح</div>
            <div v-if="model.licenseStatus === 1" class="waiting-badge">در حال بررسی</div>
          </div>
          <template v-if="model.licenseStatus === 3 || model.licenseStatus === 2">
            <div class="mt-3">علت رد درخواست:</div>
            <div class="mt-2">{{ model.licenseDescription }}</div>
          </template>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card">
          <Section title="اطلاعات دوره">
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.title" @input="model.title = $event" title="عنوان دوره" placeholder="عنوان دوره" />
            </div>
            <!-- <div class="my-3">
              <BaseText
                :maxlength="2000"
                :value="model.englishTitle"
                @input="model.englishTitle = $event"
                title="عنوان انگلیسی دوره"
                placeholder="عنوان انگلیسی دوره"
                secondTitle="عنوان چاپ مدرک"
              />
            </div> -->
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.shortDescription" @input="model.shortDescription = $event" title="توضیحات کوتاه" placeholder="توضیحات کوتاه" />
            </div>
            <div class="my-3">
              <EditorInput :value="model.fullDescription" @input="model.fullDescription = $event" title="توضیحات کلی" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <div class="date-header">اطلاعات دوره</div>
          <Section v-if="!model.courseType || model.courseType === 0 || model.courseType === 1" title="تاریخ دوره">
            <div>
              <DateTimeOffset range :value="dateRange" @input="dateRange = $event" title="تاریخ دوره" placeholder="تاریخ دوره" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>

          <Section v-if="(!model.courseType || model.courseType === 2) && model.courseType !== 0" title="تاریخ انتشار">
            <div>
              <DateTimeOffset v-model="model.releaseDate" title="تاریخ انتشار" placeholder="تاریخ انتشار" :hasDefaultDate="false" :key="dateRender" />
            </div>
          </Section>

          <Section>
            <div>
              <DateTimeOffset :value="model.hour" @input="model.hour = $event" title="ساعت شروع دوره" placeholder="ساعت شروع دوره" :hasDefaultDate="false" type="time" />
            </div>
          </Section>
          <Section title="مدت زمان دوره">
            <div>
              <BaseText :maxlength="2000" :value="model.courseDuration" @input="model.courseDuration = $event" title="مدت زمان دوره" placeholder="مدت زمان دوره" />
            </div>
          </Section>

          <Section title="مدرک">
            <ComboBox
              :searchedData="courseCertificates"
              title="اعطا گواهی معتبر"
              placeholder="اعطا گواهی معتبر"
              :selectedValue="selectedCertificate"
              @select="fillSelectedCertificate"
              :inputStyle="comboStyle"
            />
          </Section>

          <Section title="وضعیت">
            <div>
              <BaseText :maxlength="2000" :value="model.holdingType" @input="model.holdingType = $event" title="برگزاری به صورت" placeholder="برگزاری به صورت" />
            </div>
          </Section>

          <Section title="ظرفیت">
            <div>
              <CountInput inputType="number" :value="model.capacity" @input="model.capacity = $event" title="ظرفیت" placeholder="ظرفیت" />
            </div>
          </Section>

          <Section title="مهلت ثبت نام">
            <div>
              <DateTimeOffset
                :value="model.deadlineDate"
                @input="model.deadlineDate = $event"
                title="مهلت ثبت نام"
                placeholder="مهلت ثبت نام"
                :hasDefaultDate="false"
                :key="dateRender"
              />
            </div>
          </Section>

          <Section title="سطح">
            <div>
              <BaseText :maxlength="2000" :value="model.courseLevel" @input="model.courseLevel = $event" title="سطح دوره" placeholder="سطح دوره" />
            </div>
          </Section>
          <Section title="توضیحات تکمیلی">
            <div>
              <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="توضیحات تکمیلی" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="اساتید دوره">
            <MultiSelectSearch :value="selectedTeachers" @input="addTeacher" :items="courseTeachers" title="اساتید" isTag justOne />

            <b-form-checkbox v-model="model.hasSelectedTeachers" style="margin: 1rem 6rem">نمایش اساتید</b-form-checkbox>
          </Section>
          <Section title="منتورهای دوره">
            <MultiSelectSearch :value="selectedMentors" @input="addMentor" :items="courseMentors" title="منتورها" isTag />
          </Section>
        </div>
        <div class="card">
          <Section title="اپلود بنر جزییات صفحه">
            <b-row>
              <b-col>
                <ImageUploader
                  :img="model.bannerImage"
                  :uploadLoading="bannerImageLoading"
                  title="عکس بنر را انتخاب کنید"
                  secondTitle="سایز 770 × ۱۹۲۰ "
                  @uploadImage="uploadbannerImage"
                  @deleteImage="model.bannerImage = ''"
                />
              </b-col>
              <div class="mt-2">
                <BaseText v-model="model.bannerImageAlternateText" title="متن جایگزین " placeholder="متن جایگزین " labelClass="labelClass" :maxlength="2000" />
              </div>
            </b-row>
          </Section>
        </div>

        <div class="card">
          <Section title="محتوای بیشتر">
            <div>
              <EditorInput :value="model.moreContent" @input="model.moreContent = $event" title="محتوای صفحه" :hasImage="false" textAreaClass="align-items-center" />
            </div>
          </Section>
        </div>
        <div class="card">
          <Section title="محتوای بسته">
            <div>
              <EditorInput
                :value="model.packageContentDescription"
                @input="model.packageContentDescription = $event"
                title="محتوای آموزشی"
                :hasImage="false"
                textAreaClass="align-items-center"
              />
            </div>
            <div class="my-3">
              <Tags title="مهارت ها" :value="model.packageContentSkills" classes="tags" @input="model.packageContentSkills = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <BaseText
                :maxlength="2000"
                :value="model.packageContentNeededHours"
                @input="model.packageContentNeededHours = $event"
                title="ساعت مورد نیاز"
                placeholder="ساعت مورد نیاز جهت سپری کردن دوره"
              />
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="توضیحات اعطای مدرک ">
            <template>
              <div class="my-3">
                <BaseText :maxlength="2000" :value="model.certificateTitle" @input="model.certificateTitle = $event" :title="'عنوان '" :placeholder="'عنوان '" />
              </div>
            </template>
            <template>
              <div class="my-3">
                <TextAreaInput
                  :maxlength="2000"
                  :value="model.certificateDescription"
                  @input="model.certificateDescription = $event"
                  :title="'توضیحات '"
                  :placeholder="'توضیحات '"
                />
              </div>
            </template>
            <div class="card">
              <Section title="اپلود عکس">
                <template>
                  <div class="my-3">
                    <b-row>
                      <b-col>
                        <ImageUploader
                          :img="model.certificateImage"
                          :uploadLoading="certificateImageLoading"
                          title="عکس خود را انتخاب کنید"
                          secondTitle="سایز 570 * 330"
                          @uploadImage="uploadCertificateImage"
                          @deleteImage="model.certificateImage = ''"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </template>
              </Section>
            </div>
          </Section>
        </div>

        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button variant="outline-secondary" @click="$router.push($route.path.includes('faculty') ? '/list/facultyskillupcourses' : '/list/skillupcourses')">انصراف</b-button>
      <b-button :class="{ disable: isFaculty }" variant="primary ms-2 px-5" @click="addCourse">ثبت درس</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف دوره اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteCourse">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="videoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeVideoUpload">
      <template #modal-title>بارگذاری ویدئو</template>

      <div class="p-3">
        <VideoUpload
          :percent="videoPercentCompleted"
          accept="video/*"
          uploadButtonLabel="تایید"
          :loading="cropperLoading"
          @videoSourceChanged="uploadVideo($event)"
          @close="closeVideoUpload"
        />
      </div>
    </b-modal>

    <b-modal id="summaryVideoModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title no-close-on-backdrop @close="closeSummaryVideoUpload">
      <template #modal-title>بارگذاری خلاصه ویدئو</template>

      <div class="p-3">
        <VideoUpload
          :percent="summaryVideoPercentCompleted"
          accept="video/*"
          uploadButtonLabel="تایید"
          :loading="cropperLoading"
          @videoSourceChanged="uploadSummaryVideo($event)"
          @close="closeSummaryVideoUpload"
        />
      </div>
    </b-modal>

    <Toast :title="message" :error="error" :showToast="message !== ''" />
  </div>
</template>
<script>
import BaseText from '../../common/form/formModules/BaseText.vue'
import fileMannager from '../../../services/file'
import skillUpCourseProvider from '../../../services/skillUp/course'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import Section from '../../common/form/Section.vue'
import Radio from '../../common/form/formModules/Radio.vue'
import DateTimeOffset from '../../common/form/formModules/DateTimeOffset.vue'
import MultiSelectSearch from '../../common/form/MultiSelectSearch.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import VideoUpload from '../../common/form/VideoUpload.vue'
import CountInput from '../../common/form/CountInput.vue'
import axios from 'axios'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import ImageUploader from '../../user/ImageUploader.vue'
let controller = new AbortController()

export default {
  name: 'AddCourse',
  components: {
    Toast,
    Loader,
    Section,
    BaseText,
    Radio,
    DateTimeOffset,
    MultiSelectSearch,
    ComboBox,
    EditorInput,
    VideoUpload,
    CountInput,
    TextAreaInput,
    Tags,
    ImageUploader,
  },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        facultyId: '',
        collegueId: '',
        title: '',
        hasCertificate: false,
        englishTitle: '',
        courseCertificateId: '',
        shortDescription: '',
        fullDescription: '',
        extraDescription: '',
        startDate: '',
        endDate: '',
        deadlineDate: '',
        capacity: undefined,
        releaseDate: [],
        packageId: '',
        image: '',
        imageAlternateText: '',
        selectedImage: '',
        video: '',
        videoName: '',
        summaryVideo: '',
        summaryVideoName: '',
        selectedImageAlternateText: '',
        courseScore: '',
        isEnable: false,
        enableForMembers: false,
        hasSelectedTeachers: true,
        isDisplayable: false,
        courseType: '',
        price: '',
        discount: '',
        isFree: false,
        hour: '',
        numberOfSells: '',
        courseDuration: '',
        holdingType: '',
        courseCategoryId: '',
        teacherIds: [],
        mentorUserIds: [],
        bannerImage: '',
        bannerImageAlternateText: '',
        moreContent: '',
        organizational: false,
        packageContentDescription: '',
        packageContentNeededHours: '',
        packageContentSkills: [],
        seoKeyword: [],
        seoDescription: '',
        seoUrlDescription: '',
        allowSnapPay: false,
        isRecommended: false,
        order: '',
        courseLevel: '',
        certificateTitle: '',
        certificateDescription: '',
        certificateImage: '',
      },
      courseCertificates: [],
      collegues: [],
      videoLoading: false,
      summaryVideoLoading: false,
      errorText: 'وارد کردن این فیلد الزامی است',
      search: '',
      comboStyle: 'color: #495057',
      selectedTeachers: [],
      selectedMentors: [],
      selectedFaculti: '',
      selectedCollegue: '',
      cuorseTypes: [
        {
          value: 'آنلاین',
          key: 1,
        },
        {
          value: 'آفلاین',
          key: 2,
        },
        {
          value: 'حضوری',
          key: 0,
        },
      ],
      courseCategories: [],
      courseTeachers: [],
      courseMentors: [],
      courseFacultis: [],
      dateRange: [],
      images: [],
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت دوره', active: true },
      ],
      imageCrop: { width: 600, height: 200 },
      updateForm: false,
      dateRender: true,
      videoPercentCompleted: 0,
      summaryVideoPercentCompleted: 0,
      bannerImageLoading: false,
      selectedCertificate: '',
      certificateImageLoading: false,
    }
  },
  watch: {
    'model.deadlineDate'(c) {
      if (c && !c.includes('T')) {
        this.model.deadlineDate = this.model.deadlineDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.releaseDate'(c) {
      if (c && !c.includes('T')) {
        this.model.releaseDate = this.model.releaseDate.replaceAll('/', '-') + 'T00:00:00.000Z'
      }
    },
    'model.price'(c) {
      if (c && !this.submit) {
        this.model.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'model.discount'(c) {
      if (c && !this.submit) {
        this.model.discount = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
    'images.length'(c) {
      const selected = this.images[0]
      if (c <= 1) {
        if (!this.model.selectedImage && this.images.length) {
          this.model.selectedImage = selected
        }
      }
    },
    dateRange(c) {
      if (c.length > 1) {
        const start = c[0]
        const end = c[1]
        this.model.startDate = start.replaceAll('/', '-') + 'T00:00:00.000Z'
        this.model.endDate = end.replaceAll('/', '-') + 'T00:00:00.000Z'
      }

      if (c.length === 1) {
        this.model.startDate = c[0].replaceAll('/', '-') + 'T00:00:00.000Z'
      }
      if (!c) {
        this.model.startDate = null
        this.model.endDate = null
      }
    },
  },
  computed: {
    isFaculty() {
      return (
        (this.$route.path.includes('faculty') || this.$route.path.includes('support') || this.$route.path.includes('agent')) &&
        (this.model.licenseStatus === 4 || this.model.licenseStatus === 3)
      )
    },
    filteredCategory() {
      return this.courseCategories.filter((item) => {
        return item.value.includes(this.search)
      })
    },
  },
  async mounted() {
    localStorage.removeItem('entityTitle')
    await this.fetchCourseInputs()
    if (this.update) {
      await this.fetchCourse(+this.$route.params.courseId)
      this.model.isEnable = !this.model.isEnable ? true : false
    }
    // if (this.model.facultyId) this.fillSelectedFaculti()
    this.loading = false
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 10)
    setTimeout(() => {
      this.dateRender = false
    }, 3000)
  },
  methods: {
    async uploadCertificateImage(e) {
      this.certificateImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.certificateImageLoading = false
      this.model.certificateImage = req.data.data.downloadUrl
    },
    onFileSelected(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = (e) => {
        const img = new Image()
        img.src = e.target.result
        this.uploadImage(e.target.result)
      }

      reader.readAsDataURL(file)
    },
    async uploadbannerImage(e) {
      this.bannerImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.bannerImageLoading = false
      this.model.bannerImage = req.data.data.downloadUrl
    },
    closeVideoUpload() {
      this.$bvModal.hide('videoModal')
      controller.abort()
      this.videoLoading = false
      controller = new AbortController()
      this.videoPercentCompleted = 0

      this.model.video = ''
    },
    closeSummaryVideoUpload() {
      this.$bvModal.hide('summaryVideoModal')
      controller.abort()
      this.summaryVideoLoading = false
      controller = new AbortController()
      this.summaryVideoPercentCompleted = 0

      this.model.summaryVideo = ''
    },

    onOpenVideoModal() {
      if (this.model.video && this.model.video.length) return
      else this.$bvModal.show('videoModal')
    },
    onOpenSummaryVideoModal() {
      if (this.model.summaryVideo && this.model.summaryVideo.length) return
      else this.$bvModal.show('summaryVideoModal')
    },
    async uploadVideo(e) {
      try {
        this.cropperLoading = true
        this.videoLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.videoPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this.videoLoading = false

        this.model.video = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.videoPercentCompleted = 0
          this.$bvModal.hide('videoModal')
        }, 2000)
      } catch (error) {
        this.cropperLoading = false
      }
      this.cropperLoading = false
    },
    async uploadSummaryVideo(e) {
      try {
        this.cropperLoading = true
        this.summaryVideoLoading = true
        const req = await axios.post('FileManager/api/File/AddFiles', e, {
          onUploadProgress: (progressEvent) => {
            this.summaryVideoPercentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          },
          signal: controller.signal,
        })
        this.summaryVideoLoading = false

        this.model.summaryVideo = req.data.data[0].downloadUrl
        setTimeout(() => {
          this.summaryVideoPercentCompleted = 0
          this.$bvModal.hide('summaryVideoModal')
        }, 2000)
      } finally {
        this.cropperLoading = false
      }
    },
    fillSelectedFaculti(e) {
      if (!e) {
        this.model.facultyId = null
        return false
      }
      this.model.facultyId = this.courseFacultis.find((item) => item.value === e).key
      this.selectedFaculti = this.courseFacultis.find((item) => item.value === e).value
    },
    fillSelectedcollegue(e) {
      if (!e) {
        this.model.collegueId = null
        return false
      }
      this.model.collegueId = this.collegues.find((item) => item.value === e).key
      this.selectedCollegue = this.collegues.find((item) => item.value === e).value
    },
    fillSelectedCertificate(e) {
      if (!e) {
        this.model.courseCertificateId = null
        this.model.hasCertificate = false
        return false
      }
      this.model.courseCertificateId = this.courseCertificates.find((item) => item.value === e).key
      this.model.hasCertificate = true
    },
    async addCourse() {
      this.submit = true
      if (!this.model.courseCategoryId || ![0, 1, 2].includes(this.model.courseType) || !this.model.facultyId) {
        setTimeout(() => {
          window.scrollTo(0, 0)
        }, 10)
        return false
      }
      this.loading = true
      this.model.image = this.images.find((item) => item !== this.model.selectedImage)
      this.model.isFree = false
      if (!this.model.price && !this.model.discount) {
        this.model.isFree = true
      }
      if (+this.model.price === 0 && +this.model.discount === 0) {
        this.model.isFree = true
      }
      if (this.dateRange.length === 1) {
        this.model.endDate = this.model.startDate
      }
      try {
        if (this.update) {
          await this.checkData()
          const req = await skillUpCourseProvider.updateCourse({
            ...this.model,
            facultyId: this.model.facultyId,
            isEnable: !this.model.isEnable,
            releaseDate: this.model.releaseDate?.length ? new Date(this.model.releaseDate).toISOString() : undefined,
            order: this.model.order === '' ? null : +this.model.order,
          })
          if (req.status === 200) {
            this.$emit('update', !this.updateForm)
            this.loading = false
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        if (!this.model.price && !this.model.discount) {
          this.model.isFree = true
          this.model.price = 0
          this.model.discount = 0
        }
        await this.checkData()
        const req = await skillUpCourseProvider.addCourse({
          ...this.model,
          facultyId: this.model.facultyId,
          isEnable: !this.model.isEnable,
          releaseDate: this.model.releaseDate?.length ? new Date(this.model.releaseDate).toISOString() : undefined,
          order: this.model.order === '' ? null : +this.model.order,
        })
        if (req.status === 200) {
          this.message = 'دوره با موفقیت ثبت شد.'
          setTimeout(() => {
            if (this.$route.path.includes('support')) {
              this.$router.push('/list/supportskillupcourses/detail/' + req.data.data)
            } else if (this.$route.path.includes('agent')) {
              this.$router.push('/list/agentskillupcourses/detail/' + req.data.data)
            } else this.$router.push((!this.$route.path.includes('faculty') ? '/list/skillupcourses/detail/' : '/list/facultyskillupcourses/detail/') + req.data.data)
          }, 2000)
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        this.loading = false
      } finally {
        this.loading = false
      }
    },
    async fetchCourse() {
      this.loading = true
      try {
        if (this.update) {
          const req2 = await skillUpCourseProvider.getCourse(+this.$route.params.courseId)
          this.model = req2.data.data.output

          if (this.model.selectedImage) {
            this.images.push(this.model.selectedImage)
          }
          if (this.model.image) {
            this.images.push(this.model.image)
          }
          this.model.price = this.model.price.toString()
          this.model.discount = this.model.discount.toString()
          this.model.teacherIds = this.model.teachers.map((item) => {
            return { id: item.id, fullName: item.fullName }
          })

          this.model.teachers.forEach((item) => {
            const find = this.model.teacherIds.find((el) => el.id == item.id).fullName
            this.selectedTeachers.push(find)
          })
          this.model.mentorUserIds.forEach((item) => {
            const find = this.courseMentors.find((el) => el.key == item).value
            this.selectedMentors.push(find)
          })

          if (this.model.startDate) {
            this.dateRange[0] = this.model.startDate.slice(0, 10).replaceAll('-', '/')
          }
          if (this.model.endDate) {
            this.dateRange[1] = this.model.endDate.slice(0, 10).replaceAll('-', '/')
          }
          // this.dateRange = [this.model.startDate.slice(0, 10).replaceAll('-', '/') || '', this.model.endDate.slice(0, 10).replaceAll('-', '/') || '']

          this.courseFacultis.filter((item) => {
            if (item.key === this.model.facultyId) {
              this.selectedFaculti = item.value
            }
          })
          this.courseCertificates.filter((item) => {
            if (item.key === this.model.courseCertificateId) {
              this.selectedCertificate = item.value
            }
          })
          this.collegues.filter((item) => {
            if (item.key === this.model.collegueId) {
              this.selectedCollegue = item.value
            }
          })
          delete this.model.teachers
        }
        localStorage.setItem('entityTitle', this.model.title)
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchCourseInputs() {
      this.loading = true
      const req = await skillUpCourseProvider.getInputs()
      req.data.data.output.courseCategories.forEach((item) => {
        this.courseCategories.push({ value: item.title, key: item.id })
      })
      req.data.data.output.courseTeachers.forEach((item) => {
        this.courseTeachers.push({ value: item.fullName, key: item.id })
      })
      req.data.data.output.mentorUsers.forEach((item) => {
        this.courseMentors.push({ value: item.fullName, key: item.userId })
      })

      req.data.data.output.faculties.forEach((item) => {
        this.courseFacultis.push({ value: item.title, key: item.id })
      })
      this.model.facultyTitle = req.data.data.output.title
      this.model.facultyId = req.data.data.output.id

      req.data.data.output.courseCertificates.forEach((item) => {
        this.courseCertificates.push({ value: item.name, key: item.id })
      })
      req.data.data.output.collegues.forEach((item) => {
        this.collegues.push({ value: item.name, key: item.id })
      })
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.images.push(req.data.data.downloadUrl)
      this.cropperLoading = false
    },
    removeImage(payload) {
      this.images.splice(payload.index, 1)
      if (payload.image === this.model.image) {
        this.model.image = ''
      }
      if (payload.image === this.model.selectedImage) {
        this.model.selectedImage = ''
      }
      this.changeSelectedImage(payload.image)
    },

    preload(e, item) {
      this.model[item] = e
    },
    async deleteCourse() {
      this.loading = true
      try {
        const req = await skillUpCourseProvider.deleteCourse(+this.$route.params.courseId)
        this.$bvModal.hide('deleteModal')

        this.$router.push((!this.$route.path.includes('faculty') ? '/list/skillupcourses' : '/list/facultyskillupcourses') + localStorage.getItem('query'))
      } catch (error) {
        this.error = true
        this.loading = false
        this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        this.loading = false
      }
    },
    addTeacher(teachers) {
      this.model.teacherIds = []
      teachers.forEach((item) => {
        if (!this.model.teacherIds.includes(item.key)) {
          this.model.teacherIds.push(item.key)
        }
      })
    },
    addMentor(mentors) {
      this.model.mentorUserIds = []
      mentors.forEach((item) => {
        if (!this.model.mentorUserIds.includes(item.key)) {
          this.model.mentorUserIds.push(item.key)
        }
      })
    },
    addFaculti(e) {
      this.model.facultyId = e.key
    },
    checkData() {
      this.submit = true
      for (const key in this.model) {
        if (this.model[key] === '' || this.model[key] === undefined || this.model[key] === null || this.model[key] === '<p class="ql-align-right"><br></p>') {
          delete this.model[key]
        }
      }
      if (this.model.courseType === '' || this.model.courseType === undefined) {
        return false
      }
      if (this.model.price && typeof this.model.price === 'string') {
        this.model.price = this.model.price.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.price = +this.model.price
      }
      if (this.model.discount && typeof this.model.discount === 'string') {
        this.model.discount = this.model.discount.replace(/[^a-zA-Z0-9 ]/g, '')
        this.model.discount = +this.model.discount
      }
    },
    changeSelectedImage(image) {
      if (this.model.selectedImage !== image) {
        this.model.selectedImage = image
        const imageDescription = this.model.selectedImageDescription
        const imageAlternateText = this.model.selectedImageAlternateText
        this.model.selectedImageAlternateText = this.model.imageAlternateText
        this.model.selectedImageDescription = this.model.imageDescription
        this.model.imageDescription = imageDescription
        this.model.imageAlternateText = imageAlternateText
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.upload_video {
  height: 281px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 25px;
  background-color: white;
}

.video {
  width: 100%;
  height: 122px;
  border-radius: 8px;
  // margin: 20px 20px 0 20px;
}

.pro {
  width: 210px;
}

.progress-b {
  margin: 15px auto;
  direction: ltr;
  width: 85%;
  position: relative;
  left: -10px;
}

.percent {
  width: 100%;
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
  top: -28px;
  right: -10px;
}

.upload_text {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}

.second_upload_text {
  font-size: 15px;
  text-align: center;
  margin-top: 10px;
  color: rgba(153, 150, 150, 1);
}

.close_icon {
  position: absolute;
  top: 2px;
  left: 15px;
  font-size: 20px;
  color: grey;
  cursor: pointer;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo-main {
  display: flex;
  flex-wrap: wrap;
}
.uploaded-photo {
  height: 120px;
  width: 160px;
  position: relative;
  margin-left: 10px;
  margin-bottom: 10px;
  img {
    width: 100%;
    height: 100%;
  }
}
.uploaded-video {
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  z-index: 1;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    color: #ff4861;
  }
}
.previewImage {
  border-radius: 4px;
}
.previewVideo {
  border-radius: 4px;
  width: 100%;
}

.checkbox-margin {
  margin-right: 8px;
}

.section-title {
  font-size: 16px;
}
::v-deep .custom-control-label {
  margin-right: 10px !important;
}

::v-deep .custom-control-input {
  border: 1px solid #556ee6 !important;
}

::v-deep .text-muted {
  display: none;
}

.date-header {
  font-size: 17px;
  margin: 16px;
}

.selected {
  border: 3px solid #556be6;
}

.upload-video-parent {
  width: 100%;
}

::v-deep .mainInput {
  margin-right: 0;
}

::v-deep .main_box {
  width: 100%;
}

::v-deep .b-form-tags-button {
  display: none;
}

.accept-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #34c38f;
  text-align: center;
  background: rgba(52, 195, 143, 0.1);
  // border: 1px solid rgba(52, 195, 143, 0.3);
  border-radius: 100px;
}

.reject-badge {
  width: 95px;
  height: 22px;
  color: #f46a6a;
  font-size: 13px;
  text-align: center;
  background: rgba(244, 106, 106, 0.180392);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

.need-badge {
  width: 95px;
  height: 22px;
  font-size: 13px;
  color: #556ee6;
  text-align: center;
  background: rgba(85, 110, 230, 0.1);
  // border: 1px solid rgba(85, 110, 230, 0.3);
  border-radius: 100px;
}

.waiting-badge {
  width: 95px;
  height: 22px;
  color: #fcbd35;
  font-size: 13px;
  text-align: center;
  background: rgba(240, 209, 34, 0.18);
  // border: 1px solid rgba(255, 35, 87, 0.3);
  border-radius: 100px;
}

::v-deep .card {
  overflow: visible;
}

.subject {
  max-height: 150px;
  min-height: 150px;
  overflow-y: auto;
}

::v-deep .membersEnable .custom-control-label {
  margin: 0;
}

::v-deep .labelStyle {
  min-width: 80px !important;
}

.disable {
  opacity: 0.5;
  pointer-events: none;
}

.course_type_error {
  color: rgb(254, 94, 97);
}

::v-deep .input__style {
  font-weight: 600;
}

::v-deep .disableInput {
  color: black !important;
  font-weight: 600;
}

.__icon {
  display: block;
  color: #74788d;
  font-size: 45px;
  text-align: center;
}

.subject-tip {
  margin: 20px auto;
  color: #556ee6;
}
</style>
